import { Reveal } from "./Reveal";
import { Accessibility, Heart, Hand, MonitorSmartphone } from "lucide-react";

const POINTS = [
  { icon: MonitorSmartphone, title: "Accessible website", body: "Built to WCAG 2.1 AA — keyboard friendly, screen-reader labelled, with a toolbar for text size, contrast, readable font, spacing and more." },
  { icon: Hand, title: "Respectful, patient service", body: "Friendly cleaners who take the time to work the way that suits you — comfortable for NDIS, aged-care and disability support homes." },
  { icon: Heart, title: "Care for every client", body: "Clear communication, flexible scheduling and no judgement — just a genuinely helpful clean, every visit." },
];

export const AccessibilityBand = () => (
  <section id="accessibility" aria-labelledby="accessibility-heading" className="py-16 md:py-24 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="rounded-[2.5rem] bg-brand-cream border border-brand-line p-8 md:p-14">
        <Reveal>
          <div className="flex items-center gap-3 mb-4">
            <span className="grid place-items-center h-12 w-12 rounded-2xl bg-brand-blue text-white"><Accessibility className="h-7 w-7" strokeWidth={1.75} aria-hidden="true" /></span>
            <span className="text-sm font-bold uppercase tracking-wide text-brand-accentink">Accessibility first</span>
          </div>
          <h2 id="accessibility-heading" className="font-heading font-extrabold tracking-tight text-3xl md:text-4xl text-brand-blue max-w-2xl">Cleaning — and a website — that welcome everyone</h2>
          <p className="mt-4 text-lg text-brand-ink2 leading-relaxed max-w-2xl">Use the accessibility button at the bottom-right of the screen any time to adjust text size, contrast, a readable font, text spacing, a bigger cursor and more.</p>
        </Reveal>
        <div className="mt-10 grid md:grid-cols-3 gap-6">
          {POINTS.map((p, i) => (
            <Reveal key={p.title} delay={0.07 * i}>
              <div className="h-full rounded-3xl bg-white border border-brand-line p-7">
                <span className="grid place-items-center h-12 w-12 rounded-2xl bg-brand-green/15 text-brand-accentink"><p.icon className="h-6 w-6" strokeWidth={2} aria-hidden="true" /></span>
                <h3 className="mt-5 text-xl font-heading font-bold text-brand-ink">{p.title}</h3>
                <p className="mt-2 text-base text-brand-ink2 leading-relaxed">{p.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
